// extracted by mini-css-extract-plugin
export default {"UserFormRoot":"UserFormRoot---CwAf3","UserFormEditIcon":"UserFormEditIcon---VNNDM"};